import {Component, Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ErrorDialogComponent} from '../error-dialog/error-dialog.component';
import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap/modal/modal-config';

@Injectable({
  providedIn: 'root'
})
export class ErrorDialogService {

  constructor(private modalService: NgbModal) {
  }

  showErrorDialog(message) {
    //   const modalOptions: NgbModalOptions = {
    //     backdrop: 'static',
    //     size: 'md',
    //     data: message
    //   };
    //   const model = this.modalService.open(ErrorDialogComponent, modalOptions);
    //   return model.result.then((value) => {
    //     console.log(value);
    //   });
    // }
    const modal = this.modalService.open(ErrorDialogComponent, {
      backdrop: 'static',
      size: 'md',
    });
    modal.componentInstance.errorMessage = message;
  }
}
